import api from "./api";

const API_PREFIX = "api/report-subscription";

const getReportSubscriptionData = async (params) => {
	const response = await api.get(`${API_PREFIX}/all`, { params });
	return response;
};

const saveReportSubscriptionData = async (body) => {
	const response = await api.post(`${API_PREFIX}`, body);
	return response;
};

const removeReportSubscriptionData = async (id, deleteForAll = false) => {
	const response = await api.delete(`${API_PREFIX}/${id}`, {
		data: { deleteForAll }
	});
	return response;
};

const updateReportSubscriptionData = async (id, body) => {
	const response = await api.put(`${API_PREFIX}/${id}`, body);
	return response;
};

const toggleReportSubscriptionActiveStatusForUser = async (id, isActive) => {
	const response = await api.put(`${API_PREFIX}/${id}/toggle-active-for-user`, { isActive });
	return response;
};

export {
	updateReportSubscriptionData,
	getReportSubscriptionData,
	saveReportSubscriptionData,
	removeReportSubscriptionData,
	toggleReportSubscriptionActiveStatusForUser,
};
